import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { CommonApiService } from "src/app/services/common-api.service";
import { IAppAppearance } from "../../models/app-appearance.model";
import {
  loadAppAppearance,
  loadAppAppearanceFailure,
  loadAppAppearanceSuccess,
} from "./app-appearance.actions";
import { WhiteLabelService } from "src/app/services/white-label.service";
import { WhitelabelingData } from "src/app/app-data/initialwlb.data";

export const loadAppAppearanceEffect = createEffect(
  (
    actions$ = inject(Actions),
    api = inject(CommonApiService),

  ) => {
    return actions$.pipe(
      ofType(loadAppAppearance),
      exhaustMap((action) => {
        const url = `static/${action.organizationName}/config.json`;

        return api.get<IAppAppearance>(url).pipe(
          map((response) => loadAppAppearanceSuccess({ response })),
          catchError((error) => {
            // Missing config.json means the org has no custom appearance set up yet.
            // Route it through the success path so the default WhitelabelingData
            // fallback (already handled in applyWhiteLabelingEffect) applies.
            if (error.status === 404) {
              return of(loadAppAppearanceSuccess({ response: null }));
            }
            return of(loadAppAppearanceFailure({ error }));
          })
        );
      })
    );
  },

  { functional: true }
);

export const applyWhiteLabelingEffect = createEffect(
  (
    actions$ = inject(Actions),
    whiteLabelService = inject(WhiteLabelService)
  ) => {
    return actions$.pipe(
      ofType(loadAppAppearanceSuccess),
      tap((action) => {
        const { response } = action as ReturnType<typeof loadAppAppearanceSuccess>;
        if (response) {
          whiteLabelService.applyWhiteLabeling(response);
        } else {
          whiteLabelService.applyWhiteLabeling({ ...WhitelabelingData });
        }
      })
    );
  },
  { functional: true,
    dispatch: false
   }
);

